import React, { CSSProperties } from 'react';

import { IssueRowComponent } from '@qality/common-components';
import { Issue } from '@qality/common-model';
import { StatusUtils } from '@qality/common-utils';

type Props = {
  bug: Issue;
  textStyle?: CSSProperties;
  justifyContent?: string;
};

const defaultTextStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '200px',
};

export default function BugsWithStatusList({
  bug,
  textStyle = defaultTextStyle,
  justifyContent,
}: Props): JSX.Element {
  const status = bug.fields.status;
  if (status) {
    status.kind = StatusUtils.getAppearanceType(
      status.statusCategory.colorName
    );
  }

  return (
    <IssueRowComponent
      issueKey={bug.key}
      icon={bug.fields.issuetype.iconUrl}
      summary={bug.fields.summary}
      status={status}
      isClosed={StatusUtils.isDone(status)}
      textStyle={textStyle}
      justifyContent={justifyContent}
    />
  );
}
